<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title font-16 mb-0 text-dark">
      <span *ngIf="companyEmployeePolicy">{{ 'company_employee_policies.page_title_edit' | translate }}</span>
      <span *ngIf="!companyEmployeePolicy">{{ 'company_employee_policies.page_title_create' | translate }}</span>
    </p>
    
    <button
        (click)="activeModal.dismiss()"
        aria-label="Close"
        class="close"
    >
      <span
          aria-hidden="true"
          class="font-24 text-muted"
      >
        <i class="mdi mdi-close"></i>
      </span>
    </button>
  </div>
  
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-0 shadow-none">
          <div class="card-body p-0">
            <form
                (ngSubmit)="onSubmit()"
                [formGroup]="policyEditForm"
                autocomplete="off"
            >
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label class="control-label">
                      <span>{{ 'company_employee_policies.name' | translate }}</span>
                    </label>
                    
                    <input
                        class="form-control"
                        formControlName="name"
                        name="name"
                        type="text"
                    >
                    
                    <div *ngIf="submitted && f.name.errors">
                      <p
                          *ngIf="f.name.errors.required"
                          class="text-danger validation-text"
                      >
                        <span>{{ 'angular_validation.field' | translate }} </span>
                        <span>{{ 'company_employee_policies.name' | translate }} </span>
                        <span>{{ 'angular_validation.required' | translate }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <hr>
              
              <fieldset *ngIf="datetimeTypes$ | async as datetimeTypes">
                <legend>{{ 'company_employee_policies.datetime_types_category' | translate }}</legend>
                <ng-container formArrayName="employee_datetime_types">
                  <ng-container *ngFor="let datetimeTypesForm of employeeDatetimeTypes?.controls; let index = index">
                    <div [formGroupName]="index">
                      <div class="row mb-3">
                        <div class="col-12 mt-2">
                          <label class="control-label required-label"> {{ "company_employee_policies.employee_datetime_type" | translate }} </label>
                          <ng-select (change)="onEmployeeDatetimeTypeChange()"
                                     [clearable]="false"
                                     [items]="selectableDatetimeTypes"
                                     [multiple]="false"
                                     bindLabel="name"
                                     bindValue="employee_datetime_type_ID"
                                     class="custom"
                                     formControlName="employee_datetime_type_ID">
                          </ng-select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4 col-6 mt-2">
                          <label class="control-label required-label"> {{ "company_employee_policies.hours" | translate }} </label>
                          <input
                              class="form-control"
                              formControlName="hours"
                              name="hours"
                              type="number"
                          >
                        </div>
                        <div class="col-lg-4 col-6 mt-2">
                          <label class="control-label required-label">
                            <span>{{ 'company_employee_policies.range' | translate }}</span>
                          </label>
                          
                          <ng-select
                              [bindLabel]="'label'"
                              [bindValue]="'value'"
                              [clearable]="false"
                              [items]="timeframes$ | async"
                              class="custom"
                              formControlName="range"
                              name="range"
                          >
                          </ng-select>
                        </div>
                        <div class="col-lg-4 col-6 mt-2">
                          <label class="control-label">
                            <span>{{ 'company_employee_policies.can_overflow' | translate }}</span>
                          </label>
                          
                          <div>
                            <input
                                data-switch="success"
                                formControlName="can_overflow"
                                id="can_overflow-{{index}}"
                                type="checkbox"
                            >
                            
                            <label for="can_overflow-{{index}}">&nbsp;</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="mt-2 parent-enable-col col-6">
                          <label class="control-label">
                            <span>{{ 'company_employee_policies.parent_enable' | translate }}</span>
                          </label>
                          <div>
                            <input
                                (change)="onParentEnabledChange($event, index)"
                                data-switch="success"
                                formControlName="parent_enabled"
                                id="parent-enabled-{{index}}"
                                type="checkbox"
                            >
                            
                            <label for="parent-enabled-{{index}}">&nbsp;</label>
                          </div>
                        </div>
                        <div *ngIf="isParentEnabled(index)" class="col-6 mt-2">
                          <label class="control-label required"> {{ "company_employee_policies.parent_datetime_type" | translate }} </label>
                          <ng-select [clearable]="false"
                                     [multiple]="false"
                                     class="custom"
                                     formControlName="parent_datetime_type_ID">
                            <ng-option *ngFor="let option of getItemsForParentSelect(index, selectedDatetimeTypes)" [value]="option.employee_datetime_type_ID">{{ option.name }}</ng-option>
                          </ng-select>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div *ngIf="isParentEnabled(index) && employeeDatetimeTypeIDControl(index).value" class="col-12 text-right">
                          <small class="text-muted">
                            <span>{{ 'company_employee_policies.parent_type_explanation_1' | translate }}</span>
                            <span> "{{ getSelectedDatetimeType(datetimeTypes, index) }}" </span>
                            <span>{{ 'company_employee_policies.parent_type_explanation_2' | translate }}</span>
                            <span>{{ 'company_employee_policies.parent_type_explanation_3' | translate }}</span>
                          </small>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-12 d-flex align-items-end justify-content-end mb-2">
                          <label class="control-label"> </label>
                          <div>
                            <button (click)="removeDatetimeType(index)" class="btn btn-icon btn-primary" type="button">
                              <i class="mdi mdi-trash-can-outline mdi-24px"></i>
                            </button>
                          </div>
                        </div>
                        
                        <div *ngIf="submitted && hoursControl(index).errors" class=" col-12 mt-1">
                          <p *ngIf="hoursControl(index).errors.required" class="text-danger validation-text mb-0">
                            <span>{{ 'angular_validation.field' | translate }} </span>
                            <span>{{ 'company_employee_policies.hours' | translate }} </span>
                            <span>{{ 'angular_validation.required' | translate }}</span>
                          </p>
                        </div>
                        <div *ngIf="submitted && employeeDatetimeTypeIDControl(index).errors" class=" col-12 mt-1">
                          <p *ngIf="employeeDatetimeTypeIDControl(index).errors.required" class="text-danger validation-text mb-0">
                            <span>{{ 'angular_validation.field' | translate }} </span>
                            <span>{{ 'company_employee_policies.employee_datetime_type' | translate }} </span>
                            <span>{{ 'angular_validation.required' | translate }}</span>
                          </p>
                        </div>
                        <div *ngIf="submitted && parentDatetimeTypeIDControl(index).errors" class=" col-12 mt-1">
                          <p *ngIf="parentDatetimeTypeIDControl(index).errors.required" class="text-danger validation-text mb-0">
                            <span>{{ 'angular_validation.field' | translate }} </span>
                            <span>{{ 'company_employee_policies.parent_datetime_type' | translate }} </span>
                            <span>{{ 'angular_validation.required' | translate }}</span>
                          </p>
                        </div>
                      </div>
                    
                    </div>
                  </ng-container>
                </ng-container>
                <div class="row mb-3">
                  <div class="col-12 text-right">
                    <button (click)="addNewDatetimeType()" [createButton]="'add_datetime_type'" [disabled]="isCreateButtonDisabled()" type="button"></button>
                  </div>
                </div>
              </fieldset>
              
              <hr>
              
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label class="control-label">
                      <span>{{ 'company_employee_policies.legal_pause' | translate }}</span>
                    </label>
                    
                    <input
                        class="form-control"
                        formControlName="legal_pause"
                        name="legal_pause"
                        type="text"
                    >
                    
                    <div *ngIf="submitted && f.legal_pause.errors">
                      <p
                          *ngIf="f.legal_pause.errors.required"
                          class="text-danger validation-text"
                      >
                        <span>{{ 'angular_validation.field' | translate }} </span>
                        <span>{{ 'company_employee_policies.legal_pause' | translate }} </span>
                        <span>{{ 'angular_validation.required' | translate }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label class="control-label">
                      <span>{{ 'company_employee_policies.legal_pause_treshold' | translate }}</span>
                    </label>
                    
                    <input
                        class="form-control"
                        formControlName="legal_pause_treshold"
                        name="legal_pause_treshold"
                        type="text"
                    >
                    
                    <div *ngIf="submitted && f.legal_pause_treshold.errors">
                      <p
                          *ngIf="f.legal_pause_treshold.errors.required"
                          class="text-danger validation-text"
                      >
                        <span>{{ 'angular_validation.field' | translate }} </span>
                        <span>{{ 'company_employee_policies.legal_pause_treshold' | translate }} </span>
                        <span>{{ 'angular_validation.required' | translate }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <hr>
              
              <div class="row mt-2">
                <div class="col-12">
                  <div *ngIf="companyEmployeePolicy?.used_by_employees?.length > 0" class="alert alert-secondary" role="alert">
                    <span>{{ 'company_employee_policies.is_used_by_employees' | translate }} ({{companyEmployeePolicy?.used_by_employees?.length}})</span>
                    <u (click)="isCollapsed.toggle()" class="d-inline-block">{{ 'company_employee_policies.is_used_by_employees_button' | translate }}</u>
                    <div #isCollapsed="ngbCollapse"
                         [(ngbCollapse)]="!isCollapsed.collapsed">
                      <span *ngFor="let employee of companyEmployeePolicy.used_by_employees; let isLast = last">
                        {{employee.fullname}}<span *ngIf="!isLast">, </span></span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row mt-2">
                <div class="col d-flex justify-content-end">
                  <button (click)="deletePolicy()" *ngIf="companyEmployeePolicy && companyEmployeePolicy?.used_by_employees?.length === 0" class="btn btn-link text-muted p-0 mr-2" type="button">
                    <u>{{ 'global.action_delete' | translate }}</u>
                  </button>
                  <button class="btn btn-success">
                    <span>{{ 'global.action_save' | translate }}</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
